<template>
    <div style="text-align:left;">
        <div class="exportLoginData">
            <a-button size="small" @click="exportData()">{{ i18n.$t('LoginInfoToolExportData') }}</a-button>
            <label class="showTaskDrawerLabel" @click="showTaskDrawer()">{{ i18n.$t('LoginInfoToolExportTask') }}({{TaskDrawerTotal}})</label>
        </div>
        <a-row>
            <a-col :span="6">
                <h4>{{ i18n.$t('LoginInfoComputerId') }}</h4>
                <a-input v-model:value="searchComputerIdValue" style="width: 90%"/>
            </a-col>
            <a-col :span="6">
                <h4>工具类型</h4>
                <a-select
                    show-search
                    v-model:value="searchToolTypeValue"
                    style="width: 90%"
                    ref="select"
                >
                    <a-select-option v-for="item in searchToolTypeOptions" :value="item">{{item}}</a-select-option>
                </a-select>
            </a-col>
            <a-col :span="6">
                <h4>{{ i18n.$t('LoginInfoCountryCode') }}</h4>
                <a-select
                    show-search
                    v-model:value="searchCountryValue"
                    style="width: 90%"
                    ref="select"
                >
                    <a-select-option v-for="item in searchCountryOptions" :value="item">{{item}}</a-select-option>
                </a-select>
            </a-col>
            <a-col :span="6">
                <h4>{{ i18n.$t('LoginInfoSiteCode') }}</h4>
                <a-select
                    show-search
                    v-model:value="searchSiteCodeValue"
                    style="width: 90%"
                    ref="select"
                >
                    <a-select-option v-for="item in searchSiteCodeOptions" :value="item">{{item}}</a-select-option>
                </a-select>
            </a-col>
            <a-col :span="6">
                <h4>{{ i18n.$t('LoginInfoLoginTime') }}</h4>
                <a-range-picker v-model:value="searchTimeValue" />
            </a-col>
            <a-col :span="4" :offset="1">
                <a-button type="primary" size="middle" @click="searchLoginInfo()">{{ i18n.$t('LoginInfoToolSearch') }}</a-button>
                <a-button size="middle" style="margin: 29px 0 0 20px" @click="resetLoginInfo()">{{ i18n.$t('LoginInfoToolClear') }}</a-button>
            </a-col>
            <a-col :span="24">
                <a-table 
                    style="margin-top:10px;"
                    bordered
                    @change="handleTableChange"
                    :data-source="LoginInfoData"
                    :pagination="pagination"
                    :loading="loading"
                    :columns="columns"
                    :row-key="record => record.id"
                    :scroll="{ x: 1040 }">
                    <template #toolChildInfos="{ record }">
                        <label v-for="toolVersion in record.toolChildInfos" >{{`${toolVersion.toolVersion},`}}<br></label>
                    </template>
                </a-table>
                <label class="loginInfoTotalLabel">Total: {{ pagination.total }}</label>
            </a-col>
        </a-row>
        <a-drawer
            width= "800px"
            :title= "i18n.$t('LoginInfoDownloadList')"
            placement="right"
            :closable="false"
            :visible="visibleTaskDrawer"
            @close="onTaskDrawerClose"
        >
            <a-table 
                bordered
                @change="handleTaskDrawerTableChange"
                :data-source="TaskDrawerData"
                :pagination="paginationTaskDrawer"
                :columns="columnsTaskDrawer"
                :row-key="record => record.id"
                :scroll="{ x: 1040 }">
                <template #operation="{ record }">
                    <a-button type="primary" @click="DownloadTask(record.url)">{{ i18n.$t('LoginInfoDownloadButton') }}</a-button>
                </template>
            </a-table>
        </a-drawer>
    </div>
</template>

<script>
    import { useI18n } from "@/i18nPlugin";
    import { defineComponent, ref } from "vue";
    import moment from 'moment'
    import { message } from 'ant-design-vue'
    import { 
        SearchLoginInfoData,
        exportLoginInfoData,
        SearchTaskDrawerInfoData,
        SearchCountryCodeListData,
        SearchServicesCodeListData,
        SearchToolTypeListData,
    } from '../api/index';
    export default defineComponent({
        setup() {
            const i18n = useI18n();
            const token = localStorage.getItem("userToken");
            const TaskDrawerData = ref([])
            const TaskDrawerTotal = ref(0)
            const columnsTaskDrawer =  ref([
                {
                    title: "Time",
                    width: 50,
                    dataIndex: 'createTime',
                },
                {
                    title: "Path",
                    width: 100,
                    dataIndex: 'url',
                },
                {
                    title: "操作",
                    dataIndex: 'operation',
                    fixed: 'right',
                    width: 30,
                    slots: { customRender: 'operation' },
                },
            ]);
            const columns =  ref([
                {
                    title: i18n.$t('LoginInfoComputerId'),
                    width: 200,
                    dataIndex: 'featureCode',
                    fixed: 'left'
                },
                {
                    title: i18n.$t('LoginInfoCountryCode'),
                    width: 200,
                    dataIndex: 'countryCode',
                },
                {
                    title: i18n.$t('LoginInfoSiteCode'),
                    width: 200,
                    dataIndex: 'serviceCode',
                },
                {
                    title: i18n.$t('LoginInfoLoginTime'),
                    width: 200,
                    dataIndex: 'createTime',
                },
                {
                    title: i18n.$t('LoginInfoToolVersion'),
                    width: 250,
                    dataIndex: 'toolVersion',
                },
                {
                    title: "工具类型",
                    width: 200,
                    dataIndex: 'toolType',
                },
                {
                    title: i18n.$t('LoginInfoMoudleVersion'),
                    width: 200,
                    dataIndex: 'toolChildInfos',
                    slots: { customRender: 'toolChildInfos' },
                },
            ]);
            const searchCountryValue =  ref("");
            const searchCountryOptions =  ref([]);
            const searchSiteCodeValue =  ref("");
            const searchSiteCodeOptions =  ref([]);
            const searchComputerIdValue =  ref("");
            const searchToolTypeValue =  ref("");
            const searchToolTypeOptions =  ref([]);
            const searchTimeValue =  ref(null);
            let LoginInfoData =  ref([]);
            const pagination =  ref({
                total: 0,
                current: 1,
                pageSize: 10
            });
            const loading =  ref(false);
            const getLoginInfo = (currentPage,pageSize) => {
                console.log(searchTimeValue._rawValue)
                if (searchTimeValue._rawValue == null){
                    var SearchLoginInfoForm = {
                        countryCode: searchCountryValue.value,
                        serviceCode: searchSiteCodeValue.value,
                        featureCode: searchComputerIdValue.value,
                        toolType: searchToolTypeValue.value,
                        currentPage: currentPage,
                        pageSize: pageSize
                    }
                }else {
                    var SearchLoginInfoForm = {
                        countryCode: searchCountryValue.value,
                        serviceCode: searchSiteCodeValue.value,
                        featureCode: searchComputerIdValue.value,
                        toolType: searchToolTypeValue.value,
                        startTime: moment(searchTimeValue.value[0]).format("YYYY-MM-DD"),
                        endTime: moment(searchTimeValue.value[1]).format("YYYY-MM-DD"),
                        currentPage: currentPage,
                        pageSize: pageSize
                    }
                }
                SearchLoginInfoData (SearchLoginInfoForm,token).then(res => {   
                    LoginInfoData.value = res.data;
                    pagination.value.total = res.total;
                }).catch(error => console.log(error));
            };
            const handleTableChange = (pag) => {
                console.log(pag)  //current   pageSize
                pagination.value.current = pag.current;
                pagination.value.pageSize = pag.pageSize;
                getLoginInfo(pag.current,pag.pageSize);
            }

            const paginationTaskDrawer =  ref({
                total: 0,
                current: 1,
                pageSize: 10
            });
            const getCountryCodeList = () => {
                SearchCountryCodeListData(token).then(res => {   
                    searchCountryOptions.value = res.data
                    console.log(searchCountryOptions,'searchCountryOptions')
                }).catch(error => console.log(error));
            };
            const getServicesCodeList = () => {
                SearchServicesCodeListData(token).then(res => {   
                    searchSiteCodeOptions.value = res.data
                    console.log(searchSiteCodeOptions,'searchSiteCodeOptions')
                }).catch(error => console.log(error));
            };
            const getToolTypeList = () => {
                SearchToolTypeListData(token).then(res => {   
                    searchToolTypeOptions.value = res.data
                    console.log(searchToolTypeOptions,'searchToolTypeOptions')
                }).catch(error => console.log(error));
            };
            const getTaskDrawerInfo = (currentPage,pageSize) => {
                console.log(searchTimeValue._rawValue)
                SearchTaskDrawerInfoData ({
                    currentPage: currentPage,
                    pageSize: pageSize
                },token).then(res => {   
                    TaskDrawerData.value = res.data;
                    TaskDrawerTotal.value =res.total;
                }).catch(error => console.log(error));
            };
            const handleTaskDrawerTableChange = (pag) => {
                console.log(pag)  //current   pageSize
                paginationTaskDrawer.value.current = pag.current;
                paginationTaskDrawer.value.pageSize = pag.pageSize;
                getTaskDrawerInfo(pag.current,pag.pageSize);
            }

            const searchLoginInfo = () => {
                // console.log(pagination.value.current,"pagination.value.current");
                // console.log(pagination.value.pageSize,"pagination.value.pageSize");
                // console.log(searchCountryValue.value,"searchCountryValue.value");
                // console.log(searchSiteCodeValue.value,"searchSiteCodeValue.value");
                // console.log(searchComputerIdValue.value,"searchComputerIdValue.value");
                // console.log(searchTimeValue.value,"searchTimeValue.value");
                pagination.value.current = 1;
                getLoginInfo(pagination.value.current,pagination.value.pageSize);
            }

            const resetLoginInfo = () => { 
                searchCountryValue.value = "";
                searchSiteCodeValue.value = "";
                searchComputerIdValue.value = "";
                searchToolTypeValue.value = "";
                searchTimeValue.value = null;
                pagination.value.current = 1;
                // console.log(pagination.value.current,"pagination.value.current");
                // console.log(pagination.value.pageSize,"pagination.value.pageSize");
                // console.log(searchCountryValue.value,"searchCountryValue.value");
                // console.log(searchSiteCodeValue.value,"searchSiteCodeValue.value");
                // console.log(searchComputerIdValue.value,"searchComputerIdValue.value");
                // console.log(searchTimeValue.value,"searchTimeValue.value");
                getLoginInfo(pagination.value.current,pagination.value.pageSize);
            }

            const exportData = () => { 
                if (searchTimeValue._rawValue == null){
                    var SearchLoginInfoForm = {
                        countryCode: searchCountryValue.value,
                        serviceCode: searchSiteCodeValue.value,
                        featureCode: searchComputerIdValue.value,
                        toolType: searchToolTypeValue.value,
                    }
                }else {
                    var SearchLoginInfoForm = {
                        countryCode: searchCountryValue.value,
                        serviceCode: searchSiteCodeValue.value,
                        featureCode: searchComputerIdValue.value,
                        toolType: searchToolTypeValue.value,
                        startTime: moment(searchTimeValue.value[0]).format("YYYY-MM-DD"),
                        endTime: moment(searchTimeValue.value[1]).format("YYYY-MM-DD")
                    }
                }
                exportLoginInfoData (SearchLoginInfoForm,token).then(res => {
                    if(res.status == 200){
                        message.success('请到导出任务中查看进度和下载');
                    }
                }).catch(error => console.log(error));
            }

            const visibleTaskDrawer = ref(false)

            const showTaskDrawer = () => { 
                getTaskDrawerInfo(1,10);
                visibleTaskDrawer.value = true;
            }

            const onTaskDrawerClose = () => { 
                visibleTaskDrawer.value = false;
            }

            const DownloadTask = (path) => {
                window.location.href = path;
            }

            return {
                i18n,
                token,
                TaskDrawerData,
                columnsTaskDrawer,
                searchCountryValue,
                searchCountryOptions,
                searchSiteCodeValue,
                searchSiteCodeOptions,
                searchComputerIdValue,
                searchToolTypeValue,
                searchToolTypeOptions,
                searchTimeValue,
                searchLoginInfo,
                resetLoginInfo,
                getLoginInfo,
                pagination,
                loading,
                columns,
                handleTableChange,
                LoginInfoData,
                visibleTaskDrawer,
                exportData,
                showTaskDrawer,
                handleTaskDrawerTableChange,
                TaskDrawerTotal,
                getTaskDrawerInfo,
                onTaskDrawerClose,
                DownloadTask,
                getCountryCodeList,
                getServicesCodeList,
                getToolTypeList
            }
        },
        mounted() {
            this.getLoginInfo(1,10);
            this.getTaskDrawerInfo(1,10);
            this.getCountryCodeList();
            this.getServicesCodeList();
            this.getToolTypeList();
        }
    })
</script>

<style scoped>
    .exportLoginData {
        margin-top: 20px;
        text-align: right;
    }
    .showTaskDrawerLabel {
        cursor: pointer;
        font-size: 14px;
        margin-left: 10px;
    }
    .loginInfoTotalLabel {
        position: absolute;
        margin-top: -45px;
        font-weight: bold;
    }
</style>